import { useEffect } from 'react';
import { useMembersRouter as useRouter } from '@members/localization/useMembersRouter';

export default function ChallengesPage() {
  const router = useRouter();

  useEffect(() => {
    router.replace(`/challenges/active`);
  }, []);

  return null;
}
